// Canonical constants for the drawing mechanic, shared by the frontend canvas
// components and the backend stroke rasterizer so both sides render strokes
// into identical geometry and colors.
// Strokes are stored in a fixed logical width; logical height is derived per
// canvas as LOGICAL_WIDTH / aspectRatio.
export const LOGICAL_WIDTH = 1000;
// Raster exports re-render the full drawing at this fixed pixel width,
// independent of display size and device pixel ratio.
export const DRAWING_EXPORT_WIDTH = 1024;
// Surface color of the drawing board — Tailwind neutral-50 (oklch(0.985 0 0))
// resolved to sRGB. A literal so the backend renders the exact background the
// player drew on without a Tailwind dependency.
export const DRAWING_BACKGROUND_HEX = '#fafafa';
// Per-game canvas shapes (width / height). Wild Things teammates each draw one
// portrait segment that concatenates left-to-right (front-to-back) into the
// team's creature; Wanted artists draw a portrait poster.
export const WILD_THINGS_SEGMENT_ASPECT = 3 / 4;
export const WANTED_POSTER_ASPECT = 3 / 4;
//# sourceMappingURL=drawing.js.map